import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, MovimentoEstoque, TipoLogSigs, TipoMovimentoLogSigs } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MovimentoEstoqueService extends BaseResourceService<MovimentoEstoque> {

  constructor(
    protected injector: Injector
  ) {
    super(`movimentos-estoque`, injector);
  }

  public efetuarDevolucao(movimento: MovimentoEstoque): Observable<any> {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/efetuar-devolucao`, { movimento }, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }


  public efetuarTransferencia(movimento: MovimentoEstoque): Observable<any> {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/efetuar-transferencia`, { movimento }, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public recusarTransferencia(id_movimento: number, motivo_recusa: string): Observable<any> {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/recusar-transferencia/${id_movimento}`, { motivo_recusa },
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public recusarTransferenciaDev(id_movimento: number, status: string): Observable<any> {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/recusar-transferencia-dev/${id_movimento}`, { status },
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public retryIntegracaoSigs(tipo_movimento: TipoMovimentoLogSigs, tipo: TipoLogSigs, id_externo: number): Observable<void> {
    const options = { ...this.httpOptions() };

    return this.http.post<void>(
      `${this.login.cidade.id}/${this.api}/retry-integracao-sigs/`, {
      tipo_movimento,
      tipo,
      id_externo
    },
      options).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public vincularNovaLiquidacao(idMovimento: number, idLiquidacao: number, tipoLiquidacao: 'O' | 'R'): Observable<any> {
    return this.http.post<void>(
      `${this.login.cidade.id}/${this.api}/vincular-nova-liquidacao/${idMovimento}/${idLiquidacao}/${tipoLiquidacao}`, {},
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public alterarDocumentoEntrada(movimentoId: number, documento: string): Observable<any> {
    return this.http.post<void>(
      `${this.login.cidade.id}/${this.api}/alterar-documento-entrada`, { id: movimentoId, documento: documento },
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public autocompleteNomeJudicial(termo: string): Observable<{ nome: string, cpf: string }[]> {
    return this.http.get<{ nome: string, cpf: string }[]>(
      `${this.login.cidade.id}/${this.api}/autocomplete-nome-judicial?termo=${encodeURIComponent(termo)}`,
      this.httpOptions()
    ).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  public saidaRpt(orgaoId: number, data_inicial: string, data_final: string, especie: string,
    produtoUnidade: number, todosEstoques: 'S' | 'N', todosSetores: 'S' | 'N', subGrupo: number, estoqueId: number, setorId: number, ordenacao: 'data_movimento' | 'setorAlmoxarifado', setorAlmoxarifadoId: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/saida-rpt/${orgaoId}?data_inicial=${data_inicial}&data_final=${data_final}&especie=${especie}&produtoUnidade=${produtoUnidade}&todosEstoques=${todosEstoques}&todosSetores=${todosSetores}&subGrupo=${subGrupo}&estoqueId=${estoqueId}&setorId=${setorId}&ordenacao=${ordenacao}&setorAlmoxarifadoId=${setorAlmoxarifadoId}`,
      this.httpOptions()
    ).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  public itemMovimentadoRpt(orgaoId: number, data_inicial: string, data_final: string, entrada: boolean,
    todosEstoques: 'S' | 'N', todosSetores: 'S' | 'N',estoqueId: number, setorId: number, setorAlmoxarifadoId: number,
    tipoContaContabil: 'T' | 'E', planoContaCodigo: string, utilizarGrupoSubgrupo: boolean): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.login.cidade.id}/${this.api}/item-movimentado-rpt/${orgaoId}?data_inicial=${data_inicial}&data_final=${data_final}&entrada=${entrada}&todosEstoques=${todosEstoques}&todosSetores=${todosSetores}&estoqueId=${estoqueId}&setorId=${setorId}&setorAlmoxarifadoId=${setorAlmoxarifadoId}&tipoContaContabil=${tipoContaContabil}&planoContaCodigo=${encodeURIComponent(planoContaCodigo || '')}&utilizarGrupoSubgrupo=${utilizarGrupoSubgrupo}`,
      this.httpOptions()
    ).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  public vencimentoMateriaisRpt(parametros: {}): Observable<any> {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/vencimento-materiais-rpt`,
      parametros,
      // this.httpOptions()
    ).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    )
  }


}
